module.exports = __webpack_public_path__ + "img/allianz-turkish-movie-03.e531ce15.jpg";